module.exports = __webpack_public_path__ + "img/no_coupon_1.c59c8dc3.png";